import { render } from "./ban-ve-tren-xe.vue?vue&type=template&id=94ce49de&scoped=true"
import script from "./ban-ve-tren-xe.vue?vue&type=script&lang=js"
export * from "./ban-ve-tren-xe.vue?vue&type=script&lang=js"

import "./ban-ve-tren-xe.vue?vue&type=style&index=0&id=94ce49de&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ce49de"]])

export default __exports__